import { gql } from "@apollo/client";
import { CustomerOrder } from "../../../api/schema";

export const CustomerOrderListViewQuery = gql`
  query customerOrders {
    customerOrders {
      id
      customer_name
      customer_contact
      delivery_date
      state
      type
      express
      updated_at
      created_at
    }
  }
`;

export const CustomerOrderViewQuery = gql`
  query customerOrder($id: ID!) {
    customerOrder(id: $id) {
      id
      customer_name
      customer_contact
      customer_reference
      delivery_date
      notes
      state
      type
      express
      clerk {
        id
        username
        displayname
      }
      created_at
      updated_at
      positions {
        quantity
        price
        text
        type
        id
        order_number
        distributor {
          id
          short_name
        }
      }
    }
    users {
      id
      displayname
      username
    }
  }
`;

export const CreateCustomerOrderViewQuery = gql`
  query createCustomerOrder {
    users {
      id
      displayname
      username
    }
  }
`;

export const CreateCustomerOrderMutation = gql`
  mutation createCustomerQuery($values: CreateCustomerOrderInput!) {
    createCustomerOrder(values: $values) {
      id
    }
  }
`;

export const UpdateCustomerOrderMutation = gql`
  mutation updateCustomerQuery($values: UpdateCustomerOrderInput!) {
    updateCustomerOrder(values: $values) {
      id
    }
  }
`;

export const UpdateCustomerOrderPositionMutation = gql`
  mutation updateCustomerPositionQuery(
    $values: UpdateCustomerOrderPositionInput!
  ) {
    updateCustomerOrderPosition(values: $values) {
      id
      price
      quantity
      order_number
      text
      type
    }
  }
`;

export const DeleteCustomerOrderPositionMutation = gql`
  mutation DeleteCustomerOrderPosition($id: ID!) {
    deleteCustomerOrderPosition(id: $id)
  }
`;

export interface ICustomerOrderViewQuery {
  customerOrder: CustomerOrder | null;
}

export interface ICustomerOrderListViewQuery {
  customerOrders: CustomerOrder[];
}

export interface ICreateCustomerOrderMutation {
  createCustomerOrder: CustomerOrder;
}

export interface IUpdateCustomerOrderMutation {
  updateCustomerOrder: CustomerOrder;
}
